import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreCustomersByIdGetSlice } from './get';
import { coreCustomersByIdPatchSlice } from './patch';
import { coreCustomersByIdFeatureFlagsReducers, coreCustomersByIdFeatureFlagsWatchers } from './feature-flags';
import { coreCustomersByIdUsersReducers, coreCustomersByIdUsersWatchers } from './users';

export const coreCustomersByIdReducers = combineReducers({
	featureFlags: coreCustomersByIdFeatureFlagsReducers,
	get: coreCustomersByIdGetSlice.asyncReducers,
	patch: coreCustomersByIdPatchSlice.asyncReducers,
	users: coreCustomersByIdUsersReducers
});

export const coreCustomersByIdWatchers = combineAllWatchers([
	coreCustomersByIdFeatureFlagsWatchers,
	coreCustomersByIdUsersWatchers,
	coreCustomersByIdGetSlice.asyncWatchers,
	coreCustomersByIdPatchSlice.asyncWatchers
]);
